/**
 * This file contains many functions that make calls to our API and return the promises from those calls.
 */

import axios from 'axios';
import { get } from 'lodash';

import { END, eventChannel } from 'redux-saga';
import { toast } from 'react-toastify';
import Api from '../api.ts';

const FILES = '/files';

const FilesAPI = {
  /**
   * Makes call to api endpoint to get public files
   */
  async getPublicFiles(getType) {
    let param = 'user';
    if (typeof getType === 'object') {
      param = getType.getType || 'user';
    } else if (typeof getType === 'string') {
      param = getType;
    }
    const url = `${FILES}/public?type=${param}`;
    return Api.get(url);
  },

  /**
   * Makes call to api endpoint to get video files urls
   */

  async getVideoFiles() {
    return Api.get(`${FILES}/videos`);
  },

  /**
   * Makes call to api endpoint to upload public files
   * @param {object} formData the field name and file being uploaded
   *
   * @returns {promise} promise returned from the api call
   * example: {
   *  prop65: {
   *    exists: true,
   *    read: "https://somesignedurl.upload/endpoint",
   *    write: "https://somesignedurl.upload/endpoint"
   *    ...
   *  }
   * }
   */
  async uploadPublicFile(file) {
    const url = `${FILES}/public?type=admin`;
    const response = await Api.get(url);

    return eventChannel((emitter) => {
      axios({
        method: 'put',
        url: get(response, `${file.name}`).write,
        data: file.file,
        headers: {
          'Content-Type': file.type,
        },
        onUploadProgress: (progressEvent) => {
          emitter({ progressEvent });
        },
      })
        .then(() => {
          toast('File successfully uploaded', { type: 'success' });
          emitter({ data: response });
          emitter(END);
        })
        .catch((error) => {
          console.log('File upload error: ', error);
          toast('Something went wrong in file upload', {
            type: 'error',
          });
          emitter(END);
        });
      return () => {};
    });
  },
};

export default FilesAPI;
